// @flow
import React, { Component, type Node } from 'react';
import ScrollToTop from 'components/common/ScrollToTop';
import './TagsTemplate.scss';

type Props = {
  children: Node,
};

class TagsTemplate extends Component<Props> {
  render() {
    const { children } = this.props;
    return <div className="TagsTemplate">{children}</div>;
  }
}

export default TagsTemplate;



// WEBPACK FOOTER //
// ./src/components/tags/TagsTemplate/TagsTemplate.js